import { render, staticRenderFns } from "./InvoiceSuccessModal.vue?vue&type=template&id=a22c2270&scoped=true"
import script from "./InvoiceSuccessModal.vue?vue&type=script&lang=js"
export * from "./InvoiceSuccessModal.vue?vue&type=script&lang=js"
import style0 from "./InvoiceSuccessModal.vue?vue&type=style&index=0&id=a22c2270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22c2270",
  null
  
)

export default component.exports